import React from 'react'

const EmailPreference = () => {
  return (
    <div>EmailPreference</div>
  )
}

export default EmailPreference